module.exports = __webpack_public_path__ + "img/content1.0201c742.png";